import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  card: {
    background: ' rgb(255, 255, 255)',
    padding: '20px',
    border: '1px solid rgb(230, 235, 241)',
    borderRadius: '4px',
    display: 'flex',
    gap: '18px',
    flexDirection: 'column',
    width: 'auto',
    flex: 1,
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.06)',
    height: '100%'
  },
  cardTitle: {
    color: 'rgb(140, 140, 140)',
    fontWeight: 400,
    fontSize: '0.875rem',
  },
  cardValue: {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: '#535758'
  },
  icon: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px",
  },
  contentTitle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  contentValue: {
    display: 'flex',
    flexDirection: 'column'
  },
  valueLabel: {
    color: '#535758',
    fontSize: '14px'
  },
  contentSecondValue: {
    display: 'flex',
    gap: '6px',
    alignItems: 'center',
    borderTop: '2px solid #EEEEEE',
    paddingTop: '10px'
  },
  containerValue: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  }
}));
